import ProfileNotifications from 'pages/my/settings/notifications';

export default ProfileNotifications;
